import React from 'react';
import { Popup } from 'antd-mobile';
import './formationPickerPopup.css';

// 阵型编号沿用后端既有定义，站位小图只呈现各条线的人数。
const FORMATIONS = {
    1: [{ id: 1, name: '1-3-2-2' }, { id: 2, name: '1-3-3-1' }],
    2: [{ id: 3, name: '1-4-4-2' }, { id: 4, name: '1-5-3-2' },
        { id: 5, name: '1-3-5-2' }, { id: 6, name: '1-5-4-1' }, { id: 7, name: '1-4-5-1' }],
    3: [{ id: 8, name: '1-4-4-3' }, { id: 9, name: '1-5-4-2' },
        { id: 10, name: '1-4-5-2' }, { id: 11, name: '1-5-5-1' }, { id: 12, name: '1-5-3-3' }],
    4: [{ id: 13, name: '1-3-3-2' }, { id: 14, name: '1-3-4-1' }, { id: 15, name: '1-4-3-1' }],
};

const MATCH_SIZES = [
    { type: 1, label: '8 对 8', note: '8 人阵型' },
    { type: 2, label: '11 对 11', note: '11 人阵型' },
    { type: 3, label: '12 对 12', note: '12 人阵型' },
];

export default function FormationPickerPopup({ visible, teamName, typeInfo, selected, submitting,
    onClose, onSelect, onSelectSize, onConfirm }) {
    const formations = FORMATIONS[Number(typeInfo)] || [];
    const choosingSize = !typeInfo;

    return <Popup
        visible={visible}
        position='bottom'
        onMaskClick={() => !submitting && onClose()}
        bodyStyle={{ borderTopLeftRadius: 24, borderTopRightRadius: 24, maxHeight: '88vh', overflow: 'hidden' }}
        style={{ '--z-index': 1250 }}
    >
        <div className="formation-sheet">
            <div className="formation-sheet-grip" aria-hidden="true" />
            <div className="formation-sheet-header">
                <div>
                    <strong>{choosingSize ? '设置对阵人数' : '选择首发阵型'}</strong>
                    <span>{choosingSize ? '先确定本场人数' : `${formations[0]?.name.split('-').reduce((sum, n) => sum + Number(n), 0) || ''} 人阵型`}</span>
                </div>
                <button type="button" aria-label="关闭" onClick={onClose} disabled={submitting}>×</button>
            </div>

            {/* 当前操作队伍在弹窗中再次确认，避免管理员代排时选错阵型归属。 */}
            {!choosingSize && teamName && <div className="formation-target-team">
                <span>本次设置的队伍</span>
                <strong>{teamName}</strong>
            </div>}

            <div className="formation-sheet-body">
                {choosingSize ? <>
                    <div className="formation-sheet-intro">选择本场对阵人数后，再挑选适合的阵型</div>
                    <div className="formation-size-list">
                        {MATCH_SIZES.map(item => <button key={item.type} type="button"
                            disabled={submitting} onClick={() => onSelectSize(item.type)}>
                            <span className="formation-size-ball">⚽</span>
                            <span><strong>{item.label}</strong><small>{item.note}</small></span>
                            <em>选择 ›</em>
                        </button>)}
                    </div>
                </> : <>
                    <div className="formation-sheet-intro">点击阵型查看站位，确认后安排首发球员</div>
                    <div className="formation-options">
                        {formations.map(item => {
                            const lines = item.name.split('-').map(Number);
                            const active = selected === item.id;
                            return <button key={item.id} type="button" aria-pressed={active}
                                className={`formation-option ${active ? 'is-selected' : ''}`}
                                onClick={() => onSelect(item.id)}>
                                <span className="formation-mini-pitch" aria-hidden="true">
                                    {lines.map((count, line) => <span className="formation-mini-line" key={line}>
                                        {Array.from({ length: count }, (_, index) => <i key={index} />)}
                                    </span>)}
                                </span>
                                <span className="formation-option-caption">
                                    <strong>{item.name}</strong>
                                    <small>{lines.slice(1).join(' · ')}</small>
                                </span>
                                <span className="formation-option-check" aria-hidden="true">✓</span>
                            </button>;
                        })}
                    </div>
                </>}
            </div>

            {!choosingSize && <div className="formation-sheet-footer">
                <button type="button" onClick={onClose} disabled={submitting}>取消</button>
                <button type="button" className="formation-confirm" onClick={onConfirm}
                    disabled={submitting || !selected}>{submitting ? '保存中…' : `确认给${teamName || '当前队伍'}使用`}</button>
            </div>}
        </div>
    </Popup>;
}
